(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeader = document.querySelector('sticky-header.homepage-header.header-transparent');
      this.defaultColorScheme = this.stickyHeader ? this.stickyHeader.dataset.defaultColorScheme : '';
      this.transparentColorScheme = this.stickyHeader ? this.stickyHeader.dataset.transparentColorScheme : '';
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcementBar = document.querySelectorAll('.announcement-bar-section');
      this.isTransparent = this.getAttribute('data-transparent') == 'true' || false;
      this.announcementViewHeight = 0;
      this.announcementBottom = 0;

      this.announcementBar.forEach((bar) => {
        this.announcementViewHeight += bar.clientHeight;
        this.announcementBottom += bar.clientHeight;
      });

      this.updateAnnouncementViewHeight();

      if (this.isTransparent || this.isTransparent == 'true') {
        this.setTopSpace();
      }
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.addEventListener('predictiveSearchFocus', this.onPredictiveSearchFocus.bind(this));
      this.addEventListener('predictiveSearchFocusOut', this.onPredictiveSearchFocusOut.bind(this));

      this.createObserver();
    }

    onPredictiveSearchFocus() {
      if (this.stickyHeader) {
        this.stickyHeader.classList.add('predictive-search-focused');
        this.stickyHeader.classList.remove('header-transparent');
        this.stickyHeader.classList.add('gradient', 'header-transparent-hover');
        if (this.defaultColorScheme) {
          this.stickyHeader.classList.add(this.defaultColorScheme);
        }
        if (this.transparentColorScheme) {
          this.stickyHeader.classList.remove(this.transparentColorScheme);
        }
      }
    }

    onPredictiveSearchFocusOut() {
      if (this.stickyHeader) {
        this.stickyHeader.classList.remove('predictive-search-focused');
        this.stickyHeader.classList.add('header-transparent');
        this.stickyHeader.classList.remove('gradient', 'header-transparent-hover');
        if (this.defaultColorScheme) {
          this.stickyHeader.classList.remove(this.defaultColorScheme);
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-wrapper-height', `${this.headerWrapper.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let scrollUpCondition = scrollTop > this.headerBounds.bottom;
      let resetCondition = scrollTop <= this.headerBounds.top;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.stickyHeader && this.stickyHeader.classList.contains('predictive-search-focused')) return;

      if (this.isTransparent) {
        scrollUpCondition = scrollTop > this.announcementBottom;
        resetCondition = scrollTop <= this.announcementBottom;
      }

      this.updateAnnouncementViewHeight();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling down
        this.header.classList.add('scrolled-past-header');
        if (this.transparentColorScheme) {
          this.stickyHeader.classList.remove(this.transparentColorScheme);
        }
        if (this.defaultColorScheme) {
          this.stickyHeader.classList.add(this.defaultColorScheme);
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollUpCondition) {
        // Scrolling up
        this.header.classList.add('scrolled-past-header');
        if (this.transparentColorScheme) {
          this.stickyHeader.classList.remove(this.transparentColorScheme);
        }
        if (this.defaultColorScheme) {
          this.stickyHeader.classList.add(this.defaultColorScheme);
        }

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          // Prevent reveal if user is scrolling up
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (resetCondition) {
        // Reset
        document.documentElement.style.setProperty('--header-top-space', `${Math.abs(this.announcementViewHeight)}px`);
        this.header.classList.remove('scrolled-past-header');
        if (this.transparentColorScheme) {
          this.stickyHeader.classList.add(this.transparentColorScheme);
        }
        if (this.defaultColorScheme) {
          this.stickyHeader.classList.remove(this.defaultColorScheme);
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateAnnouncementViewHeight() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const announcementBar = this.announcementBar;
      var announcementOffsetBottom = 0;

      this.announcementBar.forEach((bar) => {
        announcementOffsetBottom += bar.clientHeight;
      });

      const announcementViewHeight = scrollTop - announcementOffsetBottom;

      this.announcementViewHeight = announcementViewHeight;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    setTopSpace() {
      document.documentElement.style.setProperty('--header-top-space', `${this.announcementBottom}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
